export default __webpack_public_path__ + "static/media/nodejs.454eb4e5.svg";